// extracted by mini-css-extract-plugin
module.exports = {"radioButton":"RadioButton_radioButton__18FHp","label":"RadioButton_label__3rkrq","primaryText":"RadioButton_primaryText__3vnVV","secondaryText":"RadioButton_secondaryText__2Ul_a"};